import React, {useEffect, useState} from 'react';
import {Button, FormCheck, FormControl} from "react-bootstrap";
import {useStores} from "../../stores/Context";
import {v4 as uuidv4} from "uuid";
import styles from "./CreateForm.module.scss";
import {
    FormConfiguration,
    BackCreateWidgetHome,
    WidgetTitre,
    BoutonSupprimerWidget,
    TitreConfigurerPhidget
} from "./FormConfiguration";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";
import Checkbox from "../../boiteAOutils/Checkbox";

const CreateYoutube = () => {
    const {widgetStore, uiStore, createWidgetStore} = useStores();
    const [typeForm, setTypeForm] = useState('');
    const [widgetName, setWidgetName] = useState('');
    const [widgetIdVideo, setWidgetIdVideo] = useState('');
    const [widgetAutoplay, setWidgetAutoplay] = useState('N');
    const [widgetLoop, setWidgetLoop] = useState('N');
    const [widgetFullscreen, setWidgetFullscreen] = useState('N');
    const [widgetMuted, setWidgetMuted] = useState('N');
    const [nameError, setNameError] = useState(false);
    const [idVideoError, setIdVideoError] = useState(false);

    useEffect(() => {
        if (createWidgetStore.idWidgetModification === '') {
            setTypeForm("creation");
        } else {
            setTypeForm("modification");
            widgetStore.getWidgetDataConfigById(createWidgetStore.idWidgetModification)
                .then(value => {
                    setWidgetName(value.nomWidget)
                    setWidgetIdVideo(value.config.yt_idVideo)
                    setWidgetAutoplay(value.config.yt_autoplay)
                    setWidgetLoop(value.config.yt_loop)
                    setWidgetFullscreen(value.config.yt_fullscreen)
                    setWidgetMuted(value.config.yt_muted)
                })
                .catch(error => {
                    console.log("error", error)
                });
        }
    }, [createWidgetStore.idWidgetModification]);

    function getData() {
        if (widgetIdVideo.length === 11 && widgetName.length > 0) {
            if (typeForm === "creation") {
                widgetStore.addWidgetAvailable({
                    idWidget: uuidv4(),
                    typeWidget: 'WidgetYoutube',
                    nomWidget: widgetName,
                    config: {
                        yt_idVideo: widgetIdVideo
                        , yt_autoplay: widgetAutoplay
                        , yt_loop: widgetLoop
                        , yt_fullscreen: widgetFullscreen
                        , yt_muted: widgetMuted
                    }
                });
            } else if (typeForm === "modification") {
                widgetStore.updateWidgetAvailable({
                    idWidget: createWidgetStore.idWidgetModification,
                    typeWidget: 'WidgetYoutube',
                    nomWidget: widgetName,
                    config: {
                        yt_idVideo: widgetIdVideo
                        , yt_autoplay: widgetAutoplay
                        , yt_loop: widgetLoop
                        , yt_fullscreen: widgetFullscreen
                        , yt_muted: widgetMuted
                    }
                });
            }
            uiStore.backNivOAfterAddPhidget();
        } else {
            if (widgetIdVideo.length === 0) {
                setIdVideoError(true);
            } else if (widgetIdVideo.length !== 11) {
                setIdVideoError(true);
            } else {
                setIdVideoError(false);
            }
            if (widgetName.length === 0) {
                setNameError(true);
            } else {
                setNameError(false);
            }
        }
    }

    return (
        <>
            <div>
                <TitreConfigurerPhidget/>
                <WidgetTitre titre={"YouTube"}/>
            </div>

            <div className={styles.listeChampsFormulaire}>
                <div className={styles.form_add_widget}>
                    <label>Nom du phidget </label>
                    <FormControl
                        className={`${nameError && 'border border-danger'}`}
                        onChange={(e) => setWidgetName(e.target.value)}
                        value={widgetName}
                    />
                    {nameError && <small className="text-danger">Nom obligatoire</small>}
                </div>

                <div className={styles.form_add_widget}>
                    <label>ID de la vidéo Youtube</label>
                    <FormControl
                        className={`${idVideoError && 'border border-danger'}`}
                        onChange={(e) => setWidgetIdVideo(e.target.value)}
                        value={widgetIdVideo}
                    />
                    {idVideoError && <small className="text-danger text-center w-100">ID Vidéo incorect</small>}
                    <small className="text-muted">
                        Ne pas saisir l'URL entière mais seulement la partie soulignée :<br/>
                        https://www.youtube.com/watch?v=<u>code_à_copier</u>
                    </small>
                </div>

                <div className={styles.form_add_widget}>
                    <Checkbox onClick={() => setWidgetAutoplay(widgetAutoplay === "Y" ? "N" : "Y")} label={"Autoplay"}
                              checked={(widgetAutoplay === "Y")}/>
                    <Checkbox onClick={() => setWidgetLoop(widgetLoop === "Y" ? "N" : "Y")} label={"Lecture en boucle"}
                              checked={(widgetLoop === "Y")}/>
                    <Checkbox onClick={() => setWidgetFullscreen(widgetFullscreen === "Y" ? "N" : "Y")}
                              label={"Plein écran"}
                              checked={(widgetFullscreen === "Y")}/>
                    <Checkbox onClick={() => setWidgetMuted(widgetMuted === "Y" ? "N" : "Y")} label={"Sourdine"}
                              checked={(widgetMuted === "Y")}/>
                </div>

                <div className={styles.WidgetButtonContent}>
                    {(createWidgetStore.idWidgetModification === '') ? <FormConfiguration/> :
                        <BoutonSupprimerWidget idWidget={createWidgetStore.idWidgetModification} widgetName={widgetName}
                                               typeWidget={"WidgetURL"}/>}
                    <BtnPrimary
                        onClick={getData}>{(createWidgetStore.idWidgetModification === '') ? "Ajouter à mes phidgets" : "Modifier mon phidget"}</BtnPrimary>
                </div>
            </div>
        </>
    );
};

export default CreateYoutube;